module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/office-44fd45c8c276d252d76d3caf97703986.png";